import React from 'react'

type ManagePageBarProps = {
  isEditing: boolean
  isSaving?: boolean
  onManage: () => void
  onProposeChanges: () => void
  onCancel: () => void
}

export const ManagePageBar: React.FC<ManagePageBarProps> = ({
  isEditing,
  isSaving,
  onManage,
  onProposeChanges,
  onCancel,
}) => {
  return (
    <div className="flex flex-col gap-3 rounded-xl border border-slate-300 bg-gradient-to-r from-[#E8F3F4] to-white px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-5 sm:py-4">
      <p className="text-base text-graphite-grey">
        <span className="font-semibold">You manage this page.</span>{' '}
        <span className="text-sm text-gray-600">Only you see this bar.</span>
      </p>
      <div className="flex flex-wrap gap-2 sm:shrink-0">
        {isEditing ? (
          <>
            <button
              type="button"
              onClick={onCancel}
              disabled={isSaving}
              className="rounded-full border border-gray-300 bg-white px-5 py-2 text-sm font-semibold text-graphite-grey hover:bg-gray-50 disabled:opacity-60"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onProposeChanges}
              disabled={isSaving}
              className="rounded-full bg-aqua-mint px-5 py-2 text-sm font-semibold text-white hover:bg-opacity-90 disabled:opacity-60"
            >
              {isSaving ? 'Submitting…' : 'Propose changes'}
            </button>
          </>
        ) : (
          <button
            type="button"
            onClick={onManage}
            className="rounded-full bg-aqua-mint px-6 py-2 text-sm font-semibold text-white hover:bg-opacity-90"
          >
            Manage
          </button>
        )}
      </div>
    </div>
  )
}
